module.exports = __webpack_public_path__ + "img/edit-blue.ad01f381.svg";